import { setPreparingExamsModal } from '../../store/workspace/slice';
import { CheckListSquareIcon } from '../../assets/icons';
import { useDispatch } from '../../store/store';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function PreparingExams() {
    const dispatch = useDispatch();

    const dismissFunc = () => {
        dispatch(setPreparingExamsModal(false));
    };

    return (
        <Modal
            size='sm'
            closeFunc={dismissFunc}
            icon={<CheckListSquareIcon />}
            childClassName={styles.wrapper}
            title='Preparing exams'
        >
            <p className={styles.description}>
                Your interviews are being prepared by AI.
                Come back in a few minutes to review & edit them.
            </p>
            <div className={styles.actions}>
                <Button
                    text='Ok'
                    type='Primary'
                    onClick={dismissFunc}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
